import { render } from "./MainSellerOfTheMonth.vue?vue&type=template&id=76f38b39&scoped=true"
import script from "./MainSellerOfTheMonth.vue?vue&type=script&lang=js"
export * from "./MainSellerOfTheMonth.vue?vue&type=script&lang=js"

import "./MainSellerOfTheMonth.vue?vue&type=style&index=0&id=76f38b39&scoped=true&lang=css"

import exportComponent from "D:\\Proyectos\\ERP ELECTRONICO\\ERP-FRONT\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76f38b39"]])

export default __exports__